// extracted by mini-css-extract-plugin
export default {"link":"link--G00MAHVnxB_PAVsl6OCB"};